import { FC } from 'react';
import { Button, ButtonStyles, PopupFooterProps } from '@silverfort/sf-components';
import { SendEnrollmentEmailPopupState } from '../types';

type PreviewEmailFooterProps = PopupFooterProps<SendEnrollmentEmailPopupState> & {
    onDone: (state: SendEnrollmentEmailPopupState) => void;
    onAbort: (state: SendEnrollmentEmailPopupState) => void;
};

export const PreviewEmailFooter: FC<PreviewEmailFooterProps> = ({ popupState, onDone, onAbort }) => {
    const handleCancel = () => {
        if (popupState) {
            onAbort(popupState);
        }
    };
    const handleSave = () => {
        if (popupState) {
            onDone(popupState);
        }
    };
    return (
        <div className="flex flex-1 justify-end gap-2 ">
            <Button buttonStyle={ButtonStyles.GhostSolid} text="Back" onClick={handleCancel} />
            <Button buttonStyle={ButtonStyles.PrimarySolid} text="Done" onClick={handleSave} />
        </div>
    );
};
